import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import { updateAdaUser } from '~/components/support/ducks/index-ada';
import { selectIsAboveAgeLimit } from '~/components/account/ducks/index';

const AdaMetafieldsController = () => {
	const { ada, supportVIPTagCVValue, supportLoaded } = useSelector(state => state.support);
	const { siteName, franchiseName } = useSelector(state => state.brand);
	const account = useSelector(state => state.account);
	const authenticated = useSelector(authenticationSelector);
	const isPlayerOver24 = useSelector(selectIsAboveAgeLimit);

	useEffect(() => {
		if (supportLoaded) {
			const metafields = {
				...account,
				authenticated,
				franchiseName,
				siteName,
				supportVIPTagCVValue,
				isPlayerOver24,
				customMetafields: ada.customMetafields
			};

			updateAdaUser(metafields);
		}
	}, [account, ada, authenticated, franchiseName, siteName, supportLoaded, supportVIPTagCVValue, isPlayerOver24]);

	return null;
};

export default AdaMetafieldsController;
